// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/variables.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/base.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Staatliches-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Staatliches-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Circular_regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Circular-bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/Circular_italic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Staatliches';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
  font-display: swap;
  font-weight: normal;
}

@font-face {
  font-family: 'Staatliches2';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
  font-display: swap;
  font-weight: normal;
}

@font-face {
  font-family: 'Circular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-display: swap;
  font-weight: normal;
}

@font-face {
  font-family: 'Circular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-display: swap;
  font-weight: normal;
}


@font-face {
  font-family: 'Circular Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
  font-display: swap;
  font-style: italic;
}

* {
    font-family: 'Staatliches', sans-serif;
    -webkit-font-smoothing: antialiased;
    -webkit-appearance: none;
    -moz-appearance: none;
    font-weight: normal;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: var(--dunkelgruen);
    font-size: 1em;
    text-underline-offset: 4px;
}

input,
select,
textarea {
  font-family: 'Circular', sans-serif;
  font-weight: normal;
}

input::placeholder,
select::placeholder,
textarea::placeholder {
  font-weight: normal;
}

body {
  background-color: var(--primary-light);
  margin: 0;
  padding: 20px;
  min-height: 100dvh; /* statt height:92dvh — Workaround, der je nach Seite Platz verschluckte */
  color: white;
}

ul {
    list-style-type: none; 
}

a, a:visited{
    text-decoration: none;
}

input[type="text"] {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 2px solid var(--primary-dark);
  border-radius: 10px;
  font-size: 20px;
  color: var(--primary-dark);
  font-family: 'Circular', sans-serif;
}

p, strong, a {
  -webkit-font-smoothing: antialiased;
  -webkit-appearance: none;
  -moz-appearance: none;
  font-weight: normal;
  color: var(--dunkelgruen)
}

h1 {
  color: #0150a0;
  font-size: 2em;
}

h2 {
  font-size: 1.5em;
}

h3 {
  color: var(--dunkelgruen);
}

label {
  text-transform: uppercase;
  color: var(--dunkelgruen);
}

select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  padding: 10px 40px 10px 10px;
  border: none;
  background-color: var(--mittelgruen);
  color: #9fb05f;
  border-radius: 10px;
  margin-bottom: 15px;
  padding-right: 40px;
  text-transform: none;
  font-family: 'Circular', sans-serif;
}

textarea,
input[type="password"],
input[type="number"],
input[type="date"],
input[type="time"] {
  font-family: 'Circular', sans-serif;
}

select:disabled {
  opacity: 0.5;
}

/* Einheitliche Darstellung für Platzhalteroptionen */
select option[disabled] {
  color: #9fb05f;
}

/* Wrapper for dropdowns with plus icon */
.dropdown-wrapper {
  position: relative;
  display: block;
}

.dropdown-wrapper select::-ms-expand {
  display: none;
}

.dropdown-wrapper.filled select {
  color: var(--dunkelgruen);
  font-weight: normal;
}

.dropdown-plus {
  position: absolute;
  top: 40%;
  right: 10px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  line-height: 1;
  pointer-events: none;
  font-family: 'Material Symbols Outlined';
  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 40;
  font-size: 1.5rem;
  color: #648202;
}

/* Einheitlicher Stil für Checkboxen */
input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  border: 2px solid var(--dunkelgruen);
  border-radius: 4px;
  accent-color: var(--dunkelgruen);
  appearance: auto;
}

/* Layout für Checkboxen mit Beschriftung */
.checkbox-green {
  font-family: 'Staatliches', sans-serif;
  display: flex;
  align-items: center;
  color: var(--dunkelgruen);
  gap: 8px;
  text-transform: uppercase;
}

.checkbox-green input[type="checkbox"] {
  margin: 0;
}

@media print {
  .no-print {
    display: none;
  }
  * {
    -webkit-print-color-adjust: economy;
    color: black;
    font-family: arial;
    background-color: white;
  }
}
img { max-width: 100%; height: auto; }

@media (max-width: 600px) {
  body {
    padding: 0 10px 10px;
  }
}


/* Sichtbarer Tastatur-Fokus (A11y) */
:focus-visible {
  outline: 3px solid var(--mittelblau);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;EACE,0BAA0B;EAC1B,2DAAkE;EAClE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4DAAoE;EACpE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,+DAAkE;EAClE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,+DAA+D;EAC/D,kBAAkB;EAClB,mBAAmB;AACrB;;;AAGA;EACE,8BAA8B;EAC9B,+DAAiE;EACjE,kBAAkB;EAClB,kBAAkB;AACpB;;AAMA;IACI,sCAAsC;IACtC,mCAAmC;IACnC,wBAAwB;IACxB,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;;;EAGE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,SAAS;EACT,aAAa;EACb,kBAAkB,EAAE,0EAA0E;EAC9F,YAAY;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,4BAA4B;EAC5B,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;;;;;EAKE,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA,qDAAqD;AACrD;EACE,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,wCAAwC;EACxC,kEAAkE;EAClE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,gCAAgC;EAGhC,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,mCAAmC;IACnC,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;EACzB;AACF;AACA,MAAM,eAAe,EAAE,YAAY,EAAE;;AAErC;EACE;IACE,oBAAoB;EACtB;AACF;;;AAGA,qCAAqC;AACrC;EACE,oCAAoC;EACpC,mBAAmB;AACrB","sourcesContent":["@import url('https://fonts.googleapis.com/icon?family=Material+Icons');\n@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&display=swap');\n\n@font-face {\n  font-family: 'Staatliches';\n  src: url('./assets/fonts/Staatliches-Regular.woff') format('woff');\n  font-display: swap;\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: 'Staatliches2';\n  src: url('./assets/fonts/Staatliches-Regular.woff2') format('woff2');\n  font-display: swap;\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: 'Circular';\n  src: url('./assets/fonts/Circular_regular.ttf') format('truetype');\n  font-display: swap;\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: 'Circular';\n  src: url('./assets/fonts/Circular-bold.ttf') format('truetype');\n  font-display: swap;\n  font-weight: normal;\n}\n\n\n@font-face {\n  font-family: 'Circular Italic';\n  src: url('./assets/fonts/Circular_italic.ttf') format('truetype');\n  font-display: swap;\n  font-style: italic;\n}\n\n\n@import './styles/variables.css';\n@import './styles/base.css';\n\n* {\n    font-family: 'Staatliches', sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    font-weight: normal;\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    color: var(--dunkelgruen);\n    font-size: 1em;\n    text-underline-offset: 4px;\n}\n\ninput,\nselect,\ntextarea {\n  font-family: 'Circular', sans-serif;\n  font-weight: normal;\n}\n\ninput::placeholder,\nselect::placeholder,\ntextarea::placeholder {\n  font-weight: normal;\n}\n\nbody {\n  background-color: var(--primary-light);\n  margin: 0;\n  padding: 20px;\n  min-height: 100dvh; /* statt height:92dvh — Workaround, der je nach Seite Platz verschluckte */\n  color: white;\n}\n\nul {\n    list-style-type: none; \n}\n\na, a:visited{\n    text-decoration: none;\n}\n\ninput[type=\"text\"] {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 20px;\n  border: 2px solid var(--primary-dark);\n  border-radius: 10px;\n  font-size: 20px;\n  color: var(--primary-dark);\n  font-family: 'Circular', sans-serif;\n}\n\np, strong, a {\n  -webkit-font-smoothing: antialiased;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  font-weight: normal;\n  color: var(--dunkelgruen)\n}\n\nh1 {\n  color: #0150a0;\n  font-size: 2em;\n}\n\nh2 {\n  font-size: 1.5em;\n}\n\nh3 {\n  color: var(--dunkelgruen);\n}\n\nlabel {\n  text-transform: uppercase;\n  color: var(--dunkelgruen);\n}\n\nselect {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 100%;\n  padding: 10px 40px 10px 10px;\n  border: none;\n  background-color: var(--mittelgruen);\n  color: #9fb05f;\n  border-radius: 10px;\n  margin-bottom: 15px;\n  padding-right: 40px;\n  text-transform: none;\n  font-family: 'Circular', sans-serif;\n}\n\ntextarea,\ninput[type=\"password\"],\ninput[type=\"number\"],\ninput[type=\"date\"],\ninput[type=\"time\"] {\n  font-family: 'Circular', sans-serif;\n}\n\nselect:disabled {\n  opacity: 0.5;\n}\n\n/* Einheitliche Darstellung für Platzhalteroptionen */\nselect option[disabled] {\n  color: #9fb05f;\n}\n\n/* Wrapper for dropdowns with plus icon */\n.dropdown-wrapper {\n  position: relative;\n  display: block;\n}\n\n.dropdown-wrapper select::-ms-expand {\n  display: none;\n}\n\n.dropdown-wrapper.filled select {\n  color: var(--dunkelgruen);\n  font-weight: normal;\n}\n\n.dropdown-plus {\n  position: absolute;\n  top: 40%;\n  right: 10px;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  line-height: 1;\n  pointer-events: none;\n  font-family: 'Material Symbols Outlined';\n  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 40;\n  font-size: 1.5rem;\n  color: #648202;\n}\n\n/* Einheitlicher Stil für Checkboxen */\ninput[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  border: 2px solid var(--dunkelgruen);\n  border-radius: 4px;\n  accent-color: var(--dunkelgruen);\n  -webkit-appearance: auto;\n  -moz-appearance: auto;\n  appearance: auto;\n}\n\n/* Layout für Checkboxen mit Beschriftung */\n.checkbox-green {\n  font-family: 'Staatliches', sans-serif;\n  display: flex;\n  align-items: center;\n  color: var(--dunkelgruen);\n  gap: 8px;\n  text-transform: uppercase;\n}\n\n.checkbox-green input[type=\"checkbox\"] {\n  margin: 0;\n}\n\n@media print {\n  .no-print {\n    display: none;\n  }\n  * {\n    -webkit-print-color-adjust: economy;\n    color: black;\n    font-family: arial;\n    background-color: white;\n  }\n}\nimg { max-width: 100%; height: auto; }\n\n@media (max-width: 600px) {\n  body {\n    padding: 0 10px 10px;\n  }\n}\n\n\n/* Sichtbarer Tastatur-Fokus (A11y) */\n:focus-visible {\n  outline: 3px solid var(--mittelblau);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
